import { apiClient } from './client'
import type { ShipmentSummary, Shipment, ShipmentAddition, ShipmentCodeSearchResult } from '@/types'

export const shipmentsApi = {
  getAll: () =>
    apiClient.get<ShipmentSummary[]>('/api/shipments'),

  getById: (id: string) =>
    apiClient.get<Shipment>(`/api/shipments/${id}`),

  create: () =>
    apiClient.post('/api/shipments'),

  delete: (id: string) =>
    apiClient.delete(`/api/shipments/${id}`),

  searchCode: (code: string) =>
    apiClient.get<ShipmentCodeSearchResult>('/api/shipments/search-code', { params: { code } }),

  addItem: (shipmentId: string, code: string) =>
    apiClient.post<{ addition: ShipmentAddition }>(`/api/shipments/${shipmentId}/items`, { code }),

  removeItem: (shipmentId: string, additionId: string) =>
    apiClient.delete(`/api/shipments/${shipmentId}/items/${encodeURIComponent(additionId)}`),

  updateStatus: (shipmentId: string, status: string) =>
    apiClient.put(`/api/shipments/${shipmentId}/status`, { status }),

  exportExcel: (shipmentId: string) =>
    apiClient.post(`/api/shipments/${shipmentId}/export`, {}, { responseType: 'blob' }),

  exportTxt: (shipmentId: string) =>
    apiClient.post(`/api/shipments/${shipmentId}/export-txt`, {}, { responseType: 'blob' }),
}
